<template>
  <div>
    <nav
      class="bg-gray-900 pt-2 md:pt-1 pb-1 px-1 mt-0 h-auto fixed w-full z-20 top-0"
      style="height: 50px;"
    >
    </nav>
    <div class="flex flex-col md:flex-row">
      <div class="main-content flex-1 bg-gray-100 mt-12 md:mt-2">
        <div class="bg-blue-800 p-2 shadow text-xl text-white">
          <div class="bg-grey-lighter min-h-screen flex flex-col">

            <!-- eslint-disable max-len -->
            <div
              class="container max-w-sm mx-auto flex-1 flex flex-col items-center justify-center px-2"
            >
            <!-- eslint-enable max-len -->
              <div class="bg-white px-6 py-8 rounded shadow-md text-black w-full">
                <img class="m-auto mb-10" src="@/assets/musicverse-logo.png" style="width: 150px"/>
                <!-- eslint-disable max-len -->
                <form @submit="submitForgotPassword" >
                  <input
                    type="text"
                    class="block border border-grey-light w-full p-3 rounded mb-4"
                    name="email"
                    placeholder="Email"
                    v-model="input.email"
                  />
                  <p v-if="getStatus !== 200" class="text-red-500 text-xs italic text-left">{{ getMessage }}</p>
                  <button
                    type="submit"
                    @click="submitForgotPassword"
                    :disabled="isLoading"
                    class="w-full content-center py-3 rounded bg-blue-400 text-white hover:bg-blue-600 focus:outline-none my-1"
                  >
                    <!-- <font-awesome-icon v-if="isLoading" :icon="['fa', 'spinner']" size="2x" class="pt-3 pr-0 md:pr-3 animate-spin" /> -->
                    {{ labelForgotPassword }}<img v-if="isLoading" src="@/assets/bars.svg" width="30px" class="m-auto" />
                  </button>
                  <p class="text-xs italic text-left mt-5" >After submit, please check email for forgot password</p>
                </form>
                <div v-if="isEmailHasBeenSend" class="fixed bottom-0 right-0 m-8 w-5/6 md:w-full max-w-sm" @click="toggleToast()" >
                  <input type="checkbox" class="hidden" id="footertoast" >

                  <label class="close cursor-pointer flex items-start justify-between w-full p-2  bg-green-500 h-24 rounded shadow-lg text-white" title="close" for="footertoast">
                    Email has been sent

                    <svg class="fill-current text-white" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18">
                      <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
                    </svg>
                  </label>
                </div>
                <!-- eslint-enable max-len -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// eslint-disable-next-line no-unused-vars
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ForgotPassword',
  data: () => ({
    isEmailHasBeenSend: false,
    isLoading: true,
    input: {
      email: '',
    },
  }),
  props: {
    email: {
      type: String,
      default: '',
    },
  },
  mounted() {
    this.resetMessage();
  },
  computed: {
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    labelForgotPassword() {
      return this.isLoading ? '' : 'Submit';
    },
  },
  watch: {
    getLoading: {
      immediate: true,
      handler(val) {
        this.isLoading = val;
      },
    },
    input: {
      immediate: true,
      deep: true,
      handler() {
        this.resetMessage();
      },
    },
    email: {
      immediate: true,
      handler(val) {
        this.input.email = val;
      },
    },
  },
  methods: {
    ...mapActions('NotificationModule', ['resetMessage']),
    ...mapActions('AuthModule', ['requestForgotPassword']),
    async submitForgotPassword() {
      try {
        await this.requestForgotPassword(this.input.email);
        if (this.getStatus !== 400) {
          this.isEmailHasBeenSend = true;
          setTimeout(this.toggleToast, 2000);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.log(err);
      }
    },
    toggleToast() {
      this.isEmailHasBeenSend = !this.isEmailHasBeenSend;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/ForgotPassword.vue